import { createPortal } from 'react-dom';
import { Spinner } from '@scholastic/mockingjay';

export function SwitchingOverlay({ orgName }: { orgName: string }) {
  return createPortal(
    <Spinner variant="modal" size="xl" label={`Switching to ${orgName}...`} />,
    document.body
  );
}
